import React from 'react';

import TextFilter from 'components/search_sidebar/sidebar_search';

import type { Filters } from './types';

type Slice = Pick<Filters, 'query'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function TasksIndexFilters({ query, onChange }: Props) {
  return (
    <TextFilter
      placeholder="Search for a Task or Source"
      value={query}
      onChange={event => onChange({ query: event.target.value })}
    />
  );
}
